import type { ColorScheme } from '../../context/AppContext.interface.js';

export const REPORT_THEME_LIGHT = 'evalworkbench:report-theme:light';
export const REPORT_THEME_DARK = 'evalworkbench:report-theme:dark';
export const REPORT_THEME_READY = 'evalworkbench:report-theme-ready';

export function themedReportHtml(
  html: string,
  colorScheme: ColorScheme,
): string {
  const report = new DOMParser().parseFromString(html, 'text/html');
  report.documentElement.dataset.reportTheme = colorScheme;
  report.documentElement.dataset.reportThemeManaged = 'true';
  return `<!doctype html>\n${report.documentElement.outerHTML}`;
}
